import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

let el = document.getElementById("root");

let root = ReactDOM.createRoot(el);

root.render(<App/>);